import {
  Button,
  Box,
  TextField,
  TableCell,
  MenuItem,
  styled,
} from "@mui/material";

export const ExportButton = styled(Button)(() => ({
  textTransform: 'capitalize',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '120%',
  maxWidth: '106px',
  maxHeight: '32px',
}));

export const StyledTableCell =  styled(TableCell)(() => ({ 
  backgroundColor: '#D3D3D3'
}))

export const CopyButton = styled(Button)(() => ({
  position: "absolute",
  right: 2,
}));

export const CopyLinkContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  position: "relative",
  margin: "0 auto 31px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    margin: "0 auto 48px",
  },
}));

export const Search = styled(TextField)(({ theme }) => ({
  width: 410,
  paddingBottom: "48px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    paddingBottom: "40px",
  },
}));

export const SelectedOptionButton = styled(Button)(({ theme }) => ({
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "120%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const MenuItemEllipsis = styled(MenuItem)(() => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "block",
}));